
    var riot = require('riot')
    import { Zone } from './gb-zone';
riot.tag2('gb-zone', '<gb-content-zone if="{$zone.type === \'Content\'}"></gb-content-zone> <gb-rich-content-zone if="{$zone.type === \'Rich_Content\'}"></gb-rich-content-zone> <gb-record-zone if="{$zone.type === \'Record\'}"></gb-record-zone>', '', '', function(opts) {
    this._mixin(Zone);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/template/gb-zone.tag.html